import { Checkbox, FormControlLabel } from '@mui/material';

import type { NoMedicationCheckboxProps } from './types';

export default function NoMedicationCheckbox({
  checked,
  disabled = false,
  onChange,
  labelSx,
}: NoMedicationCheckboxProps) {
  return (
    <FormControlLabel
      sx={{ alignSelf: 'flex-start' }}
      slotProps={{ typography: { sx: labelSx } }}
      control={
        <Checkbox
          checked={checked}
          disabled={disabled}
          onChange={(_event, value) => onChange(value)}
        />
      }
      label="No medication taken by the client"
    />
  );
}
